function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SecurityLogos from "segments/desktop/core-components/security-logos/security-logos";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";
import { TWO_LINK_BUTTONS_TYPE } from "segments/desktop/core-components/button/button-consts";
import SecondaryButtonDefaultProps from "segments/desktop/core-components/button/secondary-button/default-props";
import RegularButtonDefaultProps from "segments/desktop/core-components/button/regular-button/default-props";
import { StyledAsymmetricEnterpriseComponent } from "./asymmetric-enterprise-component.scss";
class AsymmetricEnterpriseComponent extends PureComponent {
    render() {
        const { fullParagraph, topColor } = this.props;
        const paragraphProps = _object_spread({}, fullParagraph);
        return /*#__PURE__*/ _jsxs(StyledAsymmetricEnterpriseComponent, {
            topColor: topColor,
            className: "asymmetric-enterprise-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "asymetric-top-line-part"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "enterprise-data",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "security-logos-wrapper",
                            children: /*#__PURE__*/ _jsx(SecurityLogos, {
                                smallLogos: true
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "full-paragraph-component-wrapper",
                            children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, paragraphProps))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "bottom-part"
                })
            ]
        });
    }
}
export { AsymmetricEnterpriseComponent as default };
AsymmetricEnterpriseComponent.defaultProps = {
    topColor: "white",
    fullParagraph: _object_spread_props(_object_spread({}, FullParagraphDefaultProps), {
        title: "monday.com for enterprise",
        body: "A fully scalable, flexible, and secure Work OS - powering your organization to outperform, faster",
        buttonConfig: _object_spread_props(_object_spread({}, FullParagraphDefaultProps.buttonConfig), {
            secondaryButtonConfig: _object_spread_props(_object_spread({}, SecondaryButtonDefaultProps), {
                color: "white",
                isWithArrow: false
            }),
            regularButtonConfig: RegularButtonDefaultProps,
            buttonType: TWO_LINK_BUTTONS_TYPE
        }),
        textColor: "white",
        textAlign: "center",
        topic: {}
    })
};
